/**
 * Admin Route with Simple Protection
 * 
 * Protects admin panel with environment flag or simple password
 */

import { useState, useEffect } from 'react';
import Dashboard from './pages/Dashboard';
import styles from './AdminRoute.module.css';

const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD || 'hijriya-admin';
const ADMIN_ENABLED = import.meta.env.VITE_ADMIN_ENABLED !== 'false';

export default function AdminRoute() {
  const [authorized, setAuthorized] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Check if already authorized in session
  useEffect(() => {
    const isAuthorized = sessionStorage.getItem('admin-authorized') === 'true';
    setAuthorized(isAuthorized);
  }, []);

  if (!ADMIN_ENABLED) {
    return (
      <div className={styles.disabled}>
        <div className={styles.disabledBox}>
          <h1>Admin Panel Disabled</h1>
          <p>
            The admin panel is disabled in this environment.
            Set <code>VITE_ADMIN_ENABLED=true</code> to enable.
          </p>
        </div>
      </div>
    );
  }

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem('admin-authorized', 'true');
      setAuthorized(true);
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  if (!authorized) {
    return (
      <div className={styles.login}>
        <div className={styles.loginBox}>
          <h1>🌙 Hijriya Admin</h1>
          <p className={styles.loginSubtitle}>Internal Use Only</p>
          
          <form onSubmit={handleLogin} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="password">Admin Password</label>
              <input
                id="password"
                type="password"
                className={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                autoFocus
              />
            </div>
            
            {error && (
              <div className={styles.error}>{error}</div>
            )}
            
            <button type="submit" className={styles.btnLogin}>
              Access Admin Panel
            </button>
          </form>
          
          <div className={styles.hint}>
            Default password: <code>hijriya-admin</code>
            <br />
            Change via <code>VITE_ADMIN_PASSWORD</code> env variable
          </div>
        </div>
      </div>
    );
  }

  const handleLogout = () => {
    sessionStorage.removeItem('admin-authorized');
    setAuthorized(false);
  };

  return <Dashboard onLogout={handleLogout} />;
}

